<script>
  import { hooksStore } from "../../stores/hooks.store";
  import { onMount } from "svelte";
  import Icon from "../../components/Icon/Icon.svelte";
  import "./sidebarLeft.func";
  import { viditelnostTabu } from "./sidebarLeft.func";
  import { userStore } from "../../stores/user.store.js";
  import { get as get_store } from "svelte/store";

  const user = get_store(userStore);
  if (user && user.modules) {
    user.modules.forEach((module, index) => {
      const m = module.slice(7);
      if (m.indexOf("_") === -1) {
        const moduleName = (m && m[0].toUpperCase() + m.slice(1)) || "";
        hooksStore.addFilter(
          "sidebarMenuComponents",
          "hooksFunctions",
          (components) => {
            // pridanie ikonky do menu
            if (hooksStore.hasFilter("sidebarMenuTop", moduleName) === false) {
              hooksStore.addFilter(
                "sidebarMenuTop",
                moduleName,
                (menuList) => {
                  menuList.push({
                    nazov: moduleName,
                    icon: m === "rozkopavky" ? "083" : "082",
                    callback: () => {
                      viditelnostTabu(m);
                    },
                  });

                  return menuList;
                },
                100 + index * 10
              );
            }

            let component;
            // vratenie komponentu
            switch (m) {
              case "rozkopavky":
                component = () => import(`../Rozkopavky/Rozkopavky.svelte`);
                break;
              case "vytlky":
                component = () => import(`../Vytlky/Vytlky.svelte`);
                break;
            }
            components.push(component);
            return components;
          },
          10
        );
      }
    });
  }

  let menuComponents = hooksStore.applyFilters("sidebarMenuComponents", []);
  let menuComponentsTop = hooksStore.applyFilters("sidebarMenuTop", []);
  let menuComponentsBottom = hooksStore.applyFilters("sidebarMenuBottom", []);
</script>

<aside class="sidebar">
  <div class="sidebar__logo">
    <img src="assets/img/logo/logo.svg" alt="SmartApp" title="SmartApp" />
  </div>
  <nav class="sidebar__nav js-tab-nav">
    <ul>
      {#each menuComponentsTop as menu}
        <li>
          <span
            class="sidebar__nav-link"
            on:click|preventDefault={menu.callback}
          >
            <Icon kod={menu.icon} />
            <p>{menu.nazov}</p>
          </span>
        </li>
      {/each}
    </ul>
    <ul>
      {#each menuComponentsBottom as menu}
        <li>
          <span
            class="sidebar__nav-link"
            on:click|preventDefault={menu.callback}
          >
            <Icon kod={menu.icon} />
            <p>{menu.nazov}</p>
          </span>
        </li>
      {/each}
    </ul>
  </nav>
  {#each menuComponents as componentPromise}
    {#await componentPromise() then component}
      <svelte:component this={component.default} />
    {/await}
  {/each}
</aside>

<style>
  .sidebar__nav > ul > li {
    cursor: pointer;
  }
</style>
